import type { FaireProductEntity } from "../../entity_types/product";

export const p_svxptmd2t4: FaireProductEntity = {
  token: "p_svxptmd2t4",
  type: "product",
  name: "Tomato Market Notepad",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/5813adee5bb374d22b8387eab5b068f4c60fb8c0a9257ab8776e6526b98c7cfa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ce8d0fe79f1c9226864404b5401cbb58f63d892491c891cce15db7cb548a4e81.jpeg",
  ],
  priceDollars: 8,
  description:
    "Ah, the ol' kitchen list. As soon as you've gotten everything on it, it's time to start a new one. So add cheer to the chore with a cute notepad! It might even make you smile as you write down salad. Again.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:48.263Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
